import { Button, Grid, Link, Tab, Tabs, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/system';
import * as React from 'react';

import UsedByPanel from '../../components/UsedByPanel';

const useStyles = makeStyles((theme) => ({
    root: {
        paddingTop: 0,
        margin: theme.spacing(2),
        // display: 'flex',
        height: `calc(${theme.cp.contentHeight} - 7rem)`,
        marginBottom: '3rem',

    },
    gridRoot: {
        // border: '1px solid black',
        // height: '100%',
        // display: 'flex',
        // flexDirection: 'row'
        marginBottom: '2rem',

    },
    recordList: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        height: '250px',
        // marginTop: theme.spacing(2),
        '&.MuiDataGrid-root .MuiDataGrid-cell:focus-within': {
            outline: 'none',
        },
        [theme.breakpoints.down('sm')]: {
            overflowY: 'scroll',
            height: '100%',
        },
    },
    buttonBar: {
        marginTop: theme.spacing(2),
    },
}));

const AccessTagEdit = (props) => {
    const classes = useStyles();
    const tag = props.data;
    const [currentTab, setCurrentTab] = React.useState(0);

    React.useEffect(() => {
        if (!props.setNavigateBackBarData || !tag) {
            return;
        }
        const label = tag.name ?? (tag.id != null ? `#${tag.id}` : '…');
        props.setNavigateBackBarData({
            title: `Access Tag: ${label}`,
            addAction: null,
            buttonText: null,
            goBackButtonAction: props.onClose,
        });
    }, [tag, props.setNavigateBackBarData, props.onClose]);

    const refMap = {};
    tag?.refs?.forEach((ref) => {
        if (!refMap[ref.type_name]) {
            refMap[ref.type_name] = [];
        }
        refMap[ref.type_name].push(ref);
    });

    console.log('node edit', props.data, tag);

    return (
        <div className={classes.root}>
            {tag?.id && (
                <Tabs value={currentTab} onChange={(e, v) => setCurrentTab(v)} indicatorColor="primary" textColor="primary" sx={{ mb: 2 }}>
                    <Tab label="General" />
                    <Tab label="Used by" />
                </Tabs>
            )}
            {currentTab === 1 && tag?.id ? (
                <UsedByPanel resource="access_tag" id={tag.id} />
            ) : (
            <Grid container direction="row" spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="body2">The list below shows which records this access tag is attached to. Access tags can be thought of as "handles" that access groups use to determine whether execution of certain action is allowed or denied.</Typography>
                    <Typography variant="body2">
                        The only exception is the <strong>Permission scope</strong> type: it shows operations for each scope that access groups grant. In other words, permission scopes constitute the internal structure of access groups and should be ignored.
                    </Typography>
                </Grid>
                {Object.keys(refMap)
                    .toSorted((a, b) => a.localeCompare(b))
                    .map((type_name) => (
                        <>
                            <Grid item xs={12}>
                                <Typography style={{ fontWeight: 500 }}>{type_name}</Typography>
                            </Grid>
                            <Grid item xs={12} container direction="row" spacing={2}>
                                {refMap[type_name].map((ref) => (
                                    <>
                                        <Grid item xs={12}>
                                            {ref.dashboard_link ? (
                                                <Link href={ref.dashboard_link} target="_blank">
                                                    {ref.name}
                                                </Link>
                                            ) : (
                                                <Typography variant="body2">{ref.name}</Typography>
                                            )}
                                        </Grid>
                                    </>
                                ))}
                            </Grid>
                            <Grid item component={Box} xs={12} display={{ sm: 'none' }}>
                                <Button variant="contained" color="primary" onClick={props.onClose}>
                                    Close
                                </Button>
                            </Grid>
                        </>
                    ))}
            </Grid>
            )}
        </div>
    );
};

export default AccessTagEdit;
